enum AssetImportError {
  BAD_URL = 'bad_url',
  DUPLICATE_ENTRY = 'duplicate_entry',
  DUPLICATE_UNMASKED_ENTRY = 'duplicate_unmasked_entry',
  DUPLICATE_IMPORT = 'duplicate_import',
  KEY_NOT_FOUND = 'key_not_found',
}

export default AssetImportError